import { render } from "./LanguageSelectorButton.vue?vue&type=template&id=57c886a1"
import script from "./LanguageSelectorButton.vue?vue&type=script&lang=js"
export * from "./LanguageSelectorButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__